  <template lang="pug">
    v-stepper(v-model="e1")
      v-snackbar(
              v-model="snackbar"
              :timeout="10000"
              color='error'
      ) {{ snackbarMessage }}  
      v-stepper-header
        v-stepper-step(:complete="e1 > 1" step="1") Detail Izin
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2") Detail Pekerjaan
        v-divider
        v-stepper-step(:complete="e1 > 3" step="3") Pencegahan/Persyaratan Khusus

      v-stepper-items
        v-stepper-content(step="1")
          v-card(class="mb-12"
            height="auto")
              v-layout(row wrap)
                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Judul Pekerjaan
                v-flex(xs7 sm5)
                  v-text-field(id="firt-judul-pekerjaan" class="inputDefault" v-model='judulPekerjaan' label="Judul Pekerjaan")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Nama Pemegang Izin / Pengawas Operasional
                v-flex(xs7 sm5)
                  v-menu(
                    v-model="searchPemegangMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="pemegangIzin.name"
                        label="Pemegang Izin"
                        readonly
                        id="firt-pemegang-izin"
                        v-on="on")
                    PemegangModal(:searchPemegang="searchPemegangMenu" @interface="searchPemegangMenu = false" @selectedUser="updatePemegangIzin")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Department / Divisi
                v-flex(xs7 sm5)
                  v-row
                    v-col
                      v-autocomplete(
                        class="inputDefault"
                        v-model="deptDivisi"
                        :items="dataUsers.department"
                        label="Department"
                        id="firt-dept-divisi"
                        )
                    v-col
                      v-text-field(id="firt-divisi" class="inputDefault" v-model='divisi' counter="100" maxlength="100" label="Divisi")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Lokasi Pekerjaan
                v-flex(xs7 sm5)
                  v-row
                    //- v-text-field(class="inputDefault" v-model='pemegangIzin')
                    v-col
                      v-autocomplete(
                        class="inputDefault"
                        label="Lokasi Pekerjaan" 
                        v-model="lokasi" 
                        :items="locations.data" 
                        no-data-text="No Data" 
                        color="blue-grey lighten-2" 
                        item-text="location_name" 
                        item-value="data" 
                        id="firt-lokasi-kerja"
                        clearable
                        chips
                        multiple)
                    v-col
                      v-text-field(id="firt-sub-lokasi" class="inputDefault" v-model='subLokasi' label="Sub Lokasi" counter="100" maxlength="100" height="42")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Perusahaan
                v-flex(xs7 sm5)
                  v-autocomplete(
                    class="inputDefault"
                    v-model="perusahaan"
                    id="firt-company"
                    :items="dataUsers.companies"
                    label="Perusahaan")
                v-flex(xs1 sm4)

                v-flex(xs3 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Tanggal Perizinan
                v-flex(xs4 sm2)
                  v-menu(
                    v-model="startMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="startDate"
                        label="mulai dari"
                        prepend-icon="event"
                        id="firt-tgl-izin-start"
                        readonly
                        v-on="on")
                    v-date-picker(id="firt-tgl-picker-start" v-model="startDate" @input="clearDate" :min="todayDate")
                v-flex(xs4 sm2)
                  v-menu(
                    v-model="endMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="endDate"
                        label="sampai dengan"
                        prepend-icon="event"
                        id="firt-tgl-izin-end"
                        readonly
                        v-on="on")
                    v-date-picker(id="firt-tgl-picker-end" v-model="endDate" @input="endMenu = false" :min="startDate")
                v-flex(xs1 sm4)
          v-btn(color="primary" @click="e1 = 2; scrollTop();" :disabled='!isPage1Complete') Continue
          v-btn(text @click="backHome()") Cancel

        v-stepper-content(step="2")
          v-card(class="mb-12"
            height="auto")
              v-layout(row wrap)
                v-flex(xs12 sm12) 
                  h3(class="headerSection") Detail Pekerja
                  br
    
                v-flex(xs1 sm1) 
                  h4(class="headerSection") No
                  br
                v-flex(xs3 sm3) 
                  h4(class="headerSection") Nama Entrans
                  br
                v-flex(xs3 sm2) 
                  h4(class="headerSection") Jabatan/Posisi
                  br
                v-flex(xs4 sm3) 
                  h4(class="headerSection") Kompetensi/Pelatihan
                  br
                v-flex(xs1 sm3) 

                v-flex(xs1 sm1)
                  p(class="headerInput") 1
                v-flex(xs3 sm3)
                  v-text-field(id="firt-nama-entrans" class="fieldInput" v-model='namaEntrans1')
                v-flex(xs3 sm2)
                  v-text-field(id="firt-jabatan" class="fieldInput" v-model="jabatanEntrans1") 
                v-flex(xs4 sm3)
                  v-text-field(id="firt-kompetensi" class="fieldInput" v-model='kompetensiEntrans1')
                v-flex(xs1 sm3) 

                v-flex(xs1 sm1)
                  p(class="headerInput") 2
                v-flex(xs3 sm3)
                  v-text-field(id="firt-nama-entrans" class="fieldInput" v-model='namaEntrans2')
                v-flex(xs3 sm2)
                  v-text-field(id="firt-jabatan" class="fieldInput" v-model="jabatanEntrans2") 
                v-flex(xs4 sm3)
                  v-text-field(id="firt-kompetensi" class="fieldInput" v-model='kompetensiEntrans2')
                v-flex(xs1 sm3) 

                v-flex(xs1 sm1)
                  p(class="headerInput") 3
                v-flex(xs3 sm3)
                  v-text-field(id="firt-nama-entrans" class="fieldInput" v-model='namaEntrans3')
                v-flex(xs3 sm2)
                  v-text-field(id="firt-jabatan" class="fieldInput" v-model="jabatanEntrans3") 
                v-flex(xs4 sm3)
                  v-text-field(id="firt-kompetensi" class="fieldInput" v-model='kompetensiEntrans3')
                v-flex(xs1 sm3) 

                v-flex(xs1 sm1)
                  p(class="headerInput") 4
                v-flex(xs3 sm3)
                  v-text-field(id="firt-nama-entrans" class="fieldInput" v-model='namaEntrans4')
                v-flex(xs3 sm2)
                  v-text-field(id="firt-jabatan" class="fieldInput" v-model="jabatanEntrans4") 
                v-flex(xs4 sm3)
                  v-text-field(id="firt-kompetensi" class="fieldInput" v-model='kompetensiEntrans4')
                v-flex(xs1 sm3) 

                v-flex(xs1 sm1) 
                  h4(class="headerSection") No
                  br
                v-flex(xs3 sm3) 
                  h4(class="headerSection") Nama Attendant(s)
                  br
                v-flex(xs3 sm2) 
                  h4(class="headerSection") Jabatan/Posisi
                  br
                v-flex(xs4 sm3) 
                  h4(class="headerSection") Kompetensi/Pelatihan
                  br
                v-flex(xs1 sm3) 

                v-flex(xs1 sm1)
                  p(class="headerInput") 1
                v-flex(xs3 sm3)
                  v-text-field(id="firt-nama-attendant" class="fieldInput" v-model='namaAttendant1')
                v-flex(xs3 sm2)
                  v-text-field(id="firt-posisi" class="fieldInput" v-model="jabatanAttendant1") 
                v-flex(xs4 sm3)
                  v-text-field(id="firt-pelatihan" class="fieldInput" v-model='kompetensiAttendant1')
                v-flex(xs1 sm3) 

                v-flex(xs1 sm1)
                  p(class="headerInput") 2
                v-flex(xs3 sm3)
                  v-text-field(id="firt-nama-attendant" class="fieldInput" v-model='namaAttendant2')
                v-flex(xs3 sm2)
                  v-text-field(id="firt-posisi" class="fieldInput" v-model="jabatanAttendant2") 
                v-flex(xs4 sm3)
                  v-text-field(id="firt-pelatihan" class="fieldInput" v-model='kompetensiAttendant2')
                v-flex(xs1 sm3) 

                v-flex(xs1 sm1)
                  p(class="headerInput") 3
                v-flex(xs3 sm3)
                  v-text-field(id="firt-nama-attendant" class="fieldInput" v-model='namaAttendant3')
                v-flex(xs3 sm2)
                  v-text-field(id="firt-posisi" class="fieldInput" v-model="jabatanAttendant3") 
                v-flex(xs4 sm3)
                  v-text-field(id="firt-pelatihan" class="fieldInput" v-model='kompetensiAttendant3')
                v-flex(xs1 sm3) 

                v-flex(xs1 sm1)
                  p(class="headerInput") 4
                v-flex(xs3 sm3)
                  v-text-field(id="firt-nama-attendant" class="fieldInput" v-model='namaAttendant4')
                v-flex(xs3 sm2)
                  v-text-field(id="firt-posisi" class="fieldInput" v-model="jabatanAttendant4") 
                v-flex(xs4 sm3)
                  v-text-field(id="firt-pelatihan" class="fieldInput" v-model='kompetensiAttendant4')
                v-flex(xs1 sm3) 

                v-flex(xs12 sm12) 
                    h3(class="headerSection") Deskripsi Detail Pekerjaan (spesifik dan tidak boleh ada tambahan kegiatan diluar cakupan yang tertera dalam izin ini)
                    br
                v-flex( sm12)
                    div(style="margin: 0 15px 0 15px;padding: 0;}")
                      ckeditor(id="firt-detailPekerjaan" :editor="editor" v-model="detailPekerjaan" :config="editorConfig")
                    br

                v-flex(xs12 sm12) 
                    h3(class="headerSection") Potensi Bahaya Umum / Risiko
                    br 
                v-flex
                    div(style="margin: 0 15px 0 15px;padding: 0;}")
                      v-layout(row wrap)
                          v-flex(xs10 sm4 v-for="(item, index) in potensiBahayaOptions" :key="index")
                            v-checkbox(id="firt-potensiBahaya" class="locationOptions" v-model="potensiBahaya" :label="item" :value="item")

                v-flex(xs12 sm12) 
                    h3(class="headerSection") Pengendalian Bahaya / Risiko
                    br 
                v-flex
                    div(style="margin: 0 15px 0 15px;padding: 0;}")
                      v-layout(row wrap)
                          v-flex(xs10 sm4 v-for="(item, index) in pengendalianBahayaOptions" :key="index")
                            v-checkbox(id="firt-pengendalianBahaya" class="locationOptions" v-model="pengendalianBahaya" :label="item" :value="item")
                          v-flex(xs10 sm4)
                            v-row(class="locationOptions" style="margin-top:-20px")
                              v-checkbox(id="firt-izinKerjaKhususLainnyaCheckbox" v-model="izinKerjaKhususLainnyaCheckbox" :label="!izinKerjaKhususLainnyaCheckbox ? 'Izin kerja khusus lainnya (sebutkan)' : ''")
                              v-text-field(id="firt-izinKerjaKhususLainnya" v-if="izinKerjaKhususLainnyaCheckbox" v-model="izinKerjaKhususLainnya" label="Izin kerja khusus lainnya" style="margin:1px")
          v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
          v-btn(color="primary" @click="e1 = 3; scrollTop();") Continue
          v-btn(text @click="backHome()") Cancel

        v-stepper-content(step="3")
          v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
                v-flex(xs12 sm12) 
                  p(class="headerSection") Daftar Periksa
                v-flex(xs5 sm6)
                  p(class="headerInput") Prosedur kerja (PPO / AKA) sudah dibuat?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-prosedur" class="selectInput" :items='checkOptions' v-model="ppoAka" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Personil telah kompeten melaksanakan pekerjaan di ruang terbatas?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-personil" class="selectInput" :items='checkOptions' v-model="PersonilKompeten" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Pengawas pekerjaan ada sepanjang waktu?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-pengawas" class="selectInput" :items='checkOptions' v-model="pengawasPekerjaan" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Kondisi oksigen dalam ruangan diperiksa?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-kondisi" class="selectInput" :items='checkOptions' v-model="kondisiOksigen" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Ada material mudah terbakar dalam radius 11 meter?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-material" class="selectInput" :items='checkOptions' v-model="materialMudahTerbakar" label="Pilih" clearable) 
                
                v-flex(xs5 sm6)
                  p(class="headerInput") Area sudah di barikade?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-barikade" class="selectInput" :items='checkOptions' v-model="barikade" label="Pilih" clearable) 
                
                v-flex(xs5 sm6)
                  p(class="headerInput") Rambu memadai dan sudah terpasang?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-rambu" class="selectInput" :items='checkOptions' v-model="rambuMemadai" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Pendeteksi gas personal ada?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-pendeteksi" class="selectInput" :items='checkOptions' v-model="pendeteksiGas" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Pencahayaan dalam ruang terbatas memadai?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-pencahayaan" class="selectInput" :items='checkOptions' v-model="pencahayaanRuang" label="Pilih" clearable)

                v-flex(xs5 sm6)
                  p(class="headerInput") Apakah ada pekerjaan panas dalam ruang terbatas?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-ruang-terbatas" class="selectInput" :items='checkOptions' v-model="adaPanas" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Peralatan darurat tersedia dan memadai?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-peralatan-darurat" class="selectInput" :items='checkOptions' v-model="peralatanDarurat" label="Pilih" clearable)

                v-flex(xs5 sm6)
                  p(class="headerInput") Alat bantu pernafasan tersedia?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-alat-bantu" class="selectInput" :items='checkOptions' v-model="alatBantuPernafasan" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Safety harness diperlukan dan tersedia?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-safety" class="selectInput" :items='checkOptions' v-model="safetyHarness" label="Pilih" clearable) 

                v-flex(xs5 sm6)
                  p(class="headerInput") Masker oksigen tersedia?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-masker" class="selectInput" :items='checkOptions' v-model="masker" label="Pilih" clearable)

                v-flex(xs5 sm6)
                  p(class="headerInput") Penguncian/isolasi energi berbahaya dilakukan?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-penguncian" class="selectInput" :items='checkOptions' v-model="isolasi" label="Pilih" clearable)

                v-flex(xs5 sm6)
                  p(class="headerInput") APAR tersedia dan memadai?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-apar" class="selectInput" :items='checkOptions' v-model="apar" label="Pilih" clearable)

                v-flex(xs5 sm6)
                  p(class="headerInput") Apakah tangga diperlukan?
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                  v-select(id="firt-tangga" class="selectInput" :items='checkOptions' v-model="butuhTangga" label="Pilih" clearable)

                v-flex(xs5 sm3) 
                  h3(class="headerSection") Upload Dokumen
                v-flex(xs6 sm5 class="attachment" v-if="!docPendukung || docPendukung.size > 10000000")
                  v-file-input(id="firt-document" :rules="rules"  label="Hanya 1 file, max 10MB" v-model="docPendukung")
                    template(v-slot:selection="{ text }" )
                      v-chip(small label color="primary")   {{ text }}
                v-flex(xs6 sm5 class="attachmentName" v-if="(docPendukung)||(docPendukung && docPendukung.size < 10000000)")
                  span(id="firt-document") {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
                  v-btn(icon color="red" @click="deleteDocPendukung('docPendukung')")
                    v-icon mdi-close
                v-flex(xs1 sm4)

                v-flex(xs12 sm12) 
                    br
                    h3(class="headerSection") Monitoring Udara/Gas
                    br 
                v-flex(xs4 sm4)
                  p(class="headerInput") Nama Petugas Pemeriksa
                v-flex(xs7 sm4)
                  v-text-field(id="firt-nama-petugas" class="inputDefault" v-model='namaPetugasMonitoringGas')
                v-flex(xs1 sm4)

                v-flex(xs4 sm4)
                  p(class="headerInput") Jabatan/Posisi Petugas Pemeriksa
                v-flex(xs7 sm4)
                  v-text-field(id="firt-petugas-pemeriksa" class="inputDefault" v-model='jabatanPetugasMonitoringGas')
                v-flex(xs1 sm4)

                v-flex(xs4 sm4)
                  p(class="headerInput") Tes Oksigen Awal (min. 19,5 %, max 23,5 %)
                v-flex(xs7 sm4)
                  v-text-field(id="firt-test-aksigen" class="inputDefault" v-model='tesOksigenAwal')
                v-flex(xs1 sm4)

                v-flex(xs4 sm4)
                  p(class="headerInput") Tes Flammable Awal (max LEL 5%)
                v-flex(xs7 sm4)
                  v-text-field(id="firt-flammable" class="inputDefault" v-model='tesFlammableAwal')
                v-flex(xs1 sm4)

                v-flex(xs4 sm4)
                  p(class="headerInput") Tes CO Awal (standar 25 ppm (8 jam))
                v-flex(xs7 sm4)
                  v-text-field(id="firt-tes-co" class="inputDefault" v-model='tesCOAwal')
                v-flex(xs1 sm4)

                v-flex(xs4 sm4)
                  p(class="headerInput") Tes H2S Awal (standar 1 ppm (8 jam))
                v-flex(xs7 sm4)
                  v-text-field(id="firt-h2s" class="inputDefault" v-model='tesH2SAwal')
                v-flex(xs1 sm4)

                v-flex(xs12 sm12) 
                    h3(class="headerSection") Alat Keselamatan
                    br 
                v-flex
                    div(style="margin: 0 15px 0 15px;padding: 0;}")
                      v-layout(row wrap)
                          v-flex(xs10 sm4 v-for="(item, index) in alatKeselamatanOptions" :key="index")
                            v-checkbox(id="firt-alat-kesehatan" class="locationOptions" v-model="alatKeselamatan" :label="item" :value="item")

                v-flex(xs12 sm12) 
                    h3(class="headerSection") Alat Pelindung Diri
                    br 
                v-flex
                    div(style="margin: 0 15px 0 15px;padding: 0;}")
                      v-layout(row wrap)
                          v-flex(xs10 sm4 v-for="(item, index) in apdOptions" :key="index")
                            v-checkbox(id="firt-alat-pelindung" class="locationOptions" v-model="apd" :label="item" :value="item")

          v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
          v-btn(class="mr-3" color='info' @click='submit(1)')
            v-icon insert_drive_file
            | &nbsp; Save as Draft
          v-btn(v-if='!submitClick' color='success' @click='submit(2)')
            v-icon send
            | &nbsp; Submit Request
          v-btn(text @click="backHome()") Cancel
  </template>

  <script>
  import helper from "../helper/index.js";
  import axios from "axios";
  import { mapState } from "vuex";
  import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import PemegangModal from './PemegangModal.vue';
import { handleError } from "../helper/handleGlobalError.js";
  export default {
    name: "AddIzinRuangTerbatas",
    components: {
      PemegangModal
    },
    props: {
      users: Array,
      edit: { type: Boolean, default: false }
    },
    data() {
      return {
        e1: 1,
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [ MyCustomUploadAdapterPlugin ],
          removePlugins : ['ImageUpload','MediaEmbed'],
          toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
          image: {
            // You need to configure the image toolbar, too, so it uses the new style buttons.
            toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
            styles: [
                // This option is equal to a situation where no style is applied.
                'full',
                // This represents an image aligned to the left.
                'alignLeft',
                // This represents an image aligned to the right.
                'alignRight'
            ]
          }
        },
        formCode: 'BIB-HSE-PPO-FRM-036-002',
        todayDate: new Date().toISOString().slice(0,10),
        judulPekerjaan: '',
        deptDivisi: [],
        divisi: '',
        detailPekerjaan: '',
        perusahaan: '',
        lokasi: [],
        subLokasi: '',
        pemegangIzin: '',

        startDate: null,
        endDate: null,
        startMenu: false,
        endMenu: false,
        searchPemegangMenu: false,
        startDateExtend: new Date().toISOString().substr(0, 10),
        endDateExtend: new Date().toISOString().substr(0, 10),
        startMenuExtend: false,
        endMenuExtend: false,

        checkOptions: ['Ya', 'Tidak'],
        ppoAka: '',
        pengawasPekerjaan:'',
        PersonilKompeten : '',
        kondisiOksigen:'',
        materialMudahTerbakar: '',
        barikade:'',
        rambuMemadai: '',
        alatBantuPernafasan: '',
        safetyHarness: '',
        pendeteksiGas: '',
        pencahayaanRuang: '',
        adaPanas: '',
        masker: '',
        isolasi: '',
        apar:'',
        butuhTangga: '',
        peralatanDarurat: '',

        namaEntrans1: '',
        namaEntrans2: '',
        namaEntrans3: '',
        namaEntrans4: '',

        jabatanEntrans1: '',
        jabatanEntrans2: '',
        jabatanEntrans3: '',
        jabatanEntrans4: '',

        kompetensiEntrans1: '',
        kompetensiEntrans2: '',
        kompetensiEntrans3: '',
        kompetensiEntrans4: '',

        namaAttendant1: '',
        namaAttendant2: '',
        namaAttendant3: '',
        namaAttendant4: '',

        jabatanAttendant1: '',
        jabatanAttendant2: '',
        jabatanAttendant3: '',
        jabatanAttendant4: '',

        kompetensiAttendant1: '',
        kompetensiAttendant2: '',
        kompetensiAttendant3: '',
        kompetensiAttendant4: '',

        namaPetugasMonitoringGas: '',
        jabatanPetugasMonitoringGas: '',
        tesOksigenAwal: '',
        tesFlammableAwal: '',
        tesCOAwal: '',
        tesH2SAwal: '',

        snackbarMessage: '',

        uploadId: null,
        docPendukung: null,
        submitClick: false,
        status: 0,

        potensiBahayaOptions: [
          'Mekanikal',
          'Hidrolik',
          'Suhu/temperatur ekstrim',
          'Elektrikal',
          'Lingkungan',
          'Api/kebakaran',
          'Penumatik',
          'Material B3',
          'Mist/Vapor'
        ],
        potensiBahaya: [],

        pengendalianBahayaOptions: [
          'Ventilasi (natural/positif/negatif)',
          'Lock Out Tag Out (LOTO)',
          'Pemisahan Bahan',
          'Rekayasa/Engineering Control (lampirkan kajian teknis)'
        ],
        izinKerjaKhususLainnyaCheckbox: false,
        izinKerjaKhususLainnya: '',
        pengendalianBahaya: [],

        alatKeselamatanOptions: [
          'Gas Detector',
          'Tangga',
          'Life Line',
          'Radio Communication',
          'Headlamp',
          'LOTO device',
          'Tripod',
          'Exhaust Fan & Duct',
          'Winch',
          'APAR',
          'Rambu - rambu'
        ],
        alatKeselamatan: [],

        apdOptions: [
          'Safety Helmet bertali',
          'Sepatu Safety',
          'Sarung tangan kulit',
          'Earmuff/Earplug',
          'Kacamatan Safety',
          'Respirator (APR)',
          'Apron Las',
          'Sarung tangan kain',
          'Face Shield',
          'Full Body Harness',
          'SCBA',
          'Sarung Tangan Kimia',
          'Coverall',
          'Safety Googles',
          'Airline',
        ],
        apd: [],

        rules: [
          value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
        ],
        emptyUpload: new File([""], "", {
          type: "",
        })
      };
    },
    mounted: async function() {
      this.$store.dispatch("fetchLocations");
      this.uploadId = Date.now();
    },
    computed: {
      ...mapState(["API_URL", "locations", "dataUsers", "dataEditRequest"]),
      selectedLoc(){
        let tempLoc = []
        let locationCode;
        
        if(this.dataUsers.location instanceof Array){
          locationCode = this.dataUsers.location[0];
        }else{
          locationCode = this.dataUsers.location;
        }

        for(let i = 0; i < this.lokasi.length; i++){
          tempLoc.push({code: locationCode, name: this.lokasi[i]});
        }
        return tempLoc
      },
      isPage1Complete: function() {
        return !!this.judulPekerjaan && !!this.perusahaan && !!this.deptDivisi && this.divisi && this.subLokasi && !!this.pemegangIzin && !(this.selectedLoc.length<1) && !!this.startDate && !!this.endDate;
      }
    },
    methods: {
      updatePemegangIzin(user) {
        this.pemegangIzin = user;
      },
      clearDate(){
        this.endDate=null;
        this.startMenu = false;
      },
      formatDate:helper.formatDate,
      scrollTop(){
        window.scrollTo(0,0);
      },
      submit(status){
        this.submitClick = true;
        this.status = status;

        let formData = new FormData();
        if (this.edit) {
          formData.append('_id', this.dataEditRequest._id);
          formData.append('ipNo', this.dataEditRequest.ipNo);
          formData.append('ipWorkflow', JSON.stringify(this.dataEditRequest.ipWorkflow));
        }
        formData.append('ipStatus', this.status);
        formData.append('ipPerusahaan', this.perusahaan );
        formData.append('ipLocation', JSON.stringify(this.selectedLoc) );
        formData.append('ipSubLokasi', this.subLokasi);
        formData.append('ipPemegangIzin', JSON.stringify(this.pemegangIzin) );
        formData.append('ipJudulPekerjaan', this.judulPekerjaan);
        formData.append('ipDeptDivisi', this.deptDivisi);
        formData.append('ipDivisi', this.divisi);
        formData.append('ipDetailPekerjaan', this.detailPekerjaan);
        formData.append('ipPelaksanaanStart', this.startDate );
        formData.append('ipPelaksanaanEnd', this.endDate );

        formData.append('ipNamaEntrans1', this.namaEntrans1);
        formData.append('ipNamaEntrans2', this.namaEntrans2);
        formData.append('ipNamaEntrans3', this.namaEntrans3);
        formData.append('ipNamaEntrans4', this.namaEntrans4);

        formData.append('ipJabatanEntrans1', this.jabatanEntrans1);
        formData.append('ipJabatanEntrans2', this.jabatanEntrans2);
        formData.append('ipJabatanEntrans3', this.jabatanEntrans3);
        formData.append('ipJabatanEntrans4', this.jabatanEntrans4);
        
        formData.append('ipKompetensiEntrans1', this.kompetensiEntrans1);
        formData.append('ipKompetensiEntrans2', this.kompetensiEntrans2);
        formData.append('ipKompetensiEntrans3', this.kompetensiEntrans3);
        formData.append('ipKompetensiEntrans4', this.kompetensiEntrans4);

        formData.append('ipNamaAttendant1', this.namaAttendant1);
        formData.append('ipNamaAttendant2', this.namaAttendant2);
        formData.append('ipNamaAttendant3', this.namaAttendant3);
        formData.append('ipNamaAttendant4', this.namaAttendant4);

        formData.append('ipJabatanAttendant1', this.jabatanAttendant1);
        formData.append('ipJabatanAttendant2', this.jabatanAttendant2);
        formData.append('ipJabatanAttendant3', this.jabatanAttendant3);
        formData.append('ipJabatanAttendant4', this.jabatanAttendant4);

        formData.append('ipKompetensiAttendant1', this.kompetensiAttendant1);
        formData.append('ipKompetensiAttendant2', this.kompetensiAttendant2);
        formData.append('ipKompetensiAttendant3', this.kompetensiAttendant3);
        formData.append('ipKompetensiAttendant4', this.kompetensiAttendant4);

        formData.append('ipNamaPetugasMonitoringGas', this.namaPetugasMonitoringGas);
        formData.append('ipJabatanPetugasMonitoringGas', this.jabatanPetugasMonitoringGas);
        formData.append('ipTesOksigenAwal', this.tesOksigenAwal);
        formData.append('ipTesFlammableAwal', this.tesFlammableAwal);
        formData.append('ipTesCOAwal', this.tesCOAwal);
        formData.append('ipTesH2SAwal', this.tesH2SAwal);

        formData.append('ipPotensiBahaya', JSON.stringify(this.potensiBahaya));
        if(this.izinKerjaKhususLainnyaCheckbox){
          this.pengendalianBahaya.push(`Izin kerja khusus lainnya (sebutkan)|${this.izinKerjaKhususLainnya}`)
        }
        formData.append('ipPengendalianBahaya', JSON.stringify(this.pengendalianBahaya));
        formData.append('ipAlatKeselamatan', JSON.stringify(this.alatKeselamatan));
        formData.append('ipApd', JSON.stringify(this.apd));

        formData.append('ipPpoAka', this.ppoAka || 'N/A');
        formData.append('ipPengawasPekerjaan', this.pengawasPekerjaan || 'N/A');
        formData.append('ipPersonilKompeten', this.PersonilKompeten || 'N/A');
        formData.append('ipKondisiOksigen', this.kondisiOksigen || 'N/A');
        formData.append('ipMaterialMudahTerbakar', this.materialMudahTerbakar || 'N/A');
        formData.append('ipBarikade', this.barikade || 'N/A');
        formData.append('ipRambuMemadai', this.rambuMemadai || 'N/A');
        formData.append('ipAlatBantuPernafasan', this.alatBantuPernafasan || 'N/A');
        formData.append('ipSafetyHarness', this.safetyHarness || 'N/A');
        formData.append('ipPendeteksiGas', this.pendeteksiGas || 'N/A');
        formData.append('ipPencahayaanRuang', this.pencahayaanRuang || 'N/A');
        formData.append('ipAdaPanas', this.adaPanas || 'N/A');
        formData.append('ipMasker', this.masker || 'N/A');
        formData.append('ipIsolasi', this.isolasi || 'N/A');
        formData.append('ipApar', this.apar || 'N/A');
        formData.append('ipButuhTangga', this.butuhTangga || 'N/A');
        formData.append('ipPeralatanDarurat', this.peralatanDarurat || 'N/A');

        formData.append('uploadId', this.uploadId );
        formData.append('ipUser', JSON.stringify(this.dataUsers) );
        formData.append('ipForm', this.formCode);

        const config = {
          method: this.edit ? "put" : "post",
          url: `${this.API_URL}/v1/requests`,
          headers: {"Content-Type": "multipart/form-data", "Authorization": `Bearer ${this.$store.state.token}`},
          data: formData
        };
        axios(config).then(res => {
          this.$store.commit("temporaryData", res);
          this.$router.push("/my-permit");
        }).catch(error => {
          handleError(error, {
            setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
            showSnackbar: (show) => { this.snackbar = show; },
            disableLoader: () => {
              this.$store.state.loader = false;
            },
          });
          this.submitClick = false;
        });
      },
      // upload(name, paramFile){
      //   if(paramFile == undefined) return ;
      //   if(paramFile.size > 10000000){
      //     paramFile = null;
      //     if(name == 'docPendukung'){
      //       this.docPendukung = this.emptyUpload;
      //     }
      //     return
      //   }else{
      //     let formData = new FormData();
      //     formData.append('uploadId', this.uploadId );
      //     formData.append(name, paramFile );
      //     axios.post(`${this.API_URL}/v1/requests/attachment/${name}`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      //   }      
      // },
      deleteDocPendukung(name){
        let id = this.uploadId.toString();      
        this.$store
          .dispatch("deleteFile", {
            uploadId: id,
            folderName: name,
          })
          .then(() => {
            this.docPendukung = null;
          })
          .catch(() => {
            this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
          });
      },
      backHome(){
        this.$router.push("/my-permit");
      },
      backStep(){
        this.e1--
      },
      docName(name){
        return this.$setFilename(name);
      }
    },
    watch: {
    docPendukung(params){
      if(params && params.size < 10000000){
         let formData = new FormData();
        formData.append('uploadId', this.uploadId );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      }
    },
      dataEditRequest: async function() {
        this.perusahaan = this.dataEditRequest.ipPerusahaan;
        // for (const item of this.locations) {
        //   let checked = false
        //   for (const element of this.dataEditRequest.ipLocation) {
        //     if(item.name == element.name) checked = true
        //   } 
        //   if(checked) this.lokasi.push(true)
        //   else this.lokasi.push(false)
        // }
        this.lokasi = [];
        for(const loc of this.dataEditRequest.ipLocation) {
          this.lokasi.push(loc.name);
        }
        for(const [index, element] of this.dataEditRequest.ipPengendalianBahaya.entries()){
          if(element.includes('Izin kerja khusus lainnya (sebutkan)')){
            this.dataEditRequest.ipPengendalianBahaya.splice(index, 1)
            this.izinKerjaKhususLainnyaCheckbox = true;
            this.izinKerjaKhususLainnya = element.split('|')[1]
          }
        }
        this.subLokasi = this.dataEditRequest.ipSubLokasi;
        this.pemegangIzin = this.dataEditRequest.ipPemegangIzin;
        this.startDate = this.formatDate(this.dataEditRequest.ipPelaksanaanStart).slice(0,10);
        this.endDate = this.formatDate(this.dataEditRequest.ipPelaksanaanEnd).slice(0,10);
        this.judulPekerjaan = this.dataEditRequest.ipJudulPekerjaan;
        this.deptDivisi = this.dataEditRequest.ipDeptDivisi;
        this.divisi = this.dataEditRequest.ipDivisi;
        this.detailPekerjaan = this.dataEditRequest.ipDetailPekerjaan;

        this.namaEntrans1 = this.dataEditRequest.ipNamaEntrans1;
        this.namaEntrans2 = this.dataEditRequest.ipNamaEntrans2;
        this.namaEntrans3 = this.dataEditRequest.ipNamaEntrans3;
        this.namaEntrans4 = this.dataEditRequest.ipNamaEntrans4;

        this.jabatanEntrans1 = this.dataEditRequest.ipJabatanEntrans1;
        this.jabatanEntrans2 = this.dataEditRequest.ipJabatanEntrans2;
        this.jabatanEntrans3 = this.dataEditRequest.ipJabatanEntrans3;
        this.jabatanEntrans4 = this.dataEditRequest.ipJabatanEntrans4;

        this.kompetensiEntrans1 = this.dataEditRequest.ipKompetensiEntrans1;
        this.kompetensiEntrans2 = this.dataEditRequest.ipKompetensiEntrans2;
        this.kompetensiEntrans3 = this.dataEditRequest.ipKompetensiEntrans3;
        this.kompetensiEntrans4 = this.dataEditRequest.ipKompetensiEntrans4;

        this.namaAttendant1 = this.dataEditRequest.ipNamaAttendant1;
        this.namaAttendant2 = this.dataEditRequest.ipNamaAttendant2;
        this.namaAttendant3 = this.dataEditRequest.ipNamaAttendant3;
        this.namaAttendant4 = this.dataEditRequest.ipNamaAttendant4;

        this.jabatanAttendant1 = this.dataEditRequest.ipJabatanAttendant1;
        this.jabatanAttendant2 = this.dataEditRequest.ipJabatanAttendant2;
        this.jabatanAttendant3 = this.dataEditRequest.ipJabatanAttendant3;
        this.jabatanAttendant4 = this.dataEditRequest.ipJabatanAttendant4;

        this.kompetensiAttendant1 = this.dataEditRequest.ipKompetensiAttendant1;
        this.kompetensiAttendant2 = this.dataEditRequest.ipKompetensiAttendant2;
        this.kompetensiAttendant3 = this.dataEditRequest.ipKompetensiAttendant3;
        this.kompetensiAttendant4 = this.dataEditRequest.ipKompetensiAttendant4;

        this.namaPetugasMonitoringGas = this.dataEditRequest.ipNamaPetugasMonitoringGas;
        this.jabatanPetugasMonitoringGas = this.dataEditRequest.ipJabatanPetugasMonitoringGas;
        this.tesOksigenAwal = this.dataEditRequest.ipTesOksigenAwal;
        this.tesFlammableAwal = this.dataEditRequest.ipTesFlammableAwal;
        this.tesCOAwal = this.dataEditRequest.ipTesCOAwal;
        this.tesH2SAwal = this.dataEditRequest.ipTesH2SAwal;

        this.potensiBahaya = this.dataEditRequest.ipPotensiBahaya;
        this.pengendalianBahaya = this.dataEditRequest.ipPengendalianBahaya;
        this.alatKeselamatan = this.dataEditRequest.ipAlatKeselamatan;
        this.apd = this.dataEditRequest.ipApd;

        this.ppoAka = this.dataEditRequest.ipPpoAka;
        this.pengawasPekerjaan = this.dataEditRequest.ipPengawasPekerjaan;
        this.PersonilKompeten = this.dataEditRequest.ipPersonilKompeten;
        this.kondisiOksigen = this.dataEditRequest.ipKondisiOksigen;
        this.materialMudahTerbakar = this.dataEditRequest.ipMaterialMudahTerbakar;
        this.barikade = this.dataEditRequest.ipBarikade;
        this.rambuMemadai = this.dataEditRequest.ipRambuMemadai;
        this.alatBantuPernafasan = this.dataEditRequest.ipAlatBantuPernafasan;
        this.safetyHarness = this.dataEditRequest.ipSafetyHarness;
        this.pendeteksiGas = this.dataEditRequest.ipPendeteksiGas;
        this.pencahayaanRuang = this.dataEditRequest.ipPencahayaanRuang;
        this.adaPanas = this.dataEditRequest.ipAdaPanas;
        this.masker = this.dataEditRequest.ipMasker;
        this.isolasi = this.dataEditRequest.ipIsolasi;
        this.apar = this.dataEditRequest.ipApar;
        this.butuhTangga = this.dataEditRequest.ipButuhTangga;
        this.peralatanDarurat = this.dataEditRequest.ipPeralatanDarurat;

        this.uploadId = this.dataEditRequest.uploadId;
        this.docPendukung = this.dataEditRequest.ipAttachmentFiles.docPendukung;
      },
    }
  };
  </script>

  <style>
  .mustFill {
    color: #EA5164;
  }
  </style>
